import { message as $message } from 'antd'
import { createAPI } from '@/utils/modal'
import ImageEditDrawer from '@/modules/goods/components/ImageEditDrawer'
import { getCurrentModalMaxZindex } from '@/utils/modal'

export const createManager = () => {
    let drawer = null

    const open = ({ onChange, ...restProps }) => {
        if (Array.isArray(restProps.images) && restProps.images.length) {
            if (drawer) {
                drawer.update({
                    visible: true,
                    zIndex: getCurrentModalMaxZindex(),
                    dataSource: restProps,
                    onChange
                })

                return
            }

            drawer = createAPI(ImageEditDrawer, {
                destroyOnClose: false,
                dataSource: restProps,
                onChange
            })

            return
        }

        $message.warn('请先上传图片')
    }

    return {
        open
    }
}

export const manager = createManager()
